import { Box } from "@mui/material";
import React from "react";

const SearchSkeleton: React.FC = () => {
  return (
    <Box style={{ padding: "20px" }}>
      {/* Search Header Skeleton */}
      <Box style={{ marginBottom: "20px" }}>
        <Box
          style={{
            width: "200px",
            height: "32px",
            backgroundColor: "#f0f0f0",
            borderRadius: "4px",
            marginBottom: "8px",
            animation: "pulse 1.5s ease-in-out infinite",
          }}
        />
        <Box
          style={{
            width: "300px",
            height: "16px",
            backgroundColor: "#f0f0f0",
            borderRadius: "4px",
            animation: "pulse 1.5s ease-in-out infinite",
          }}
        />
      </Box>

      {/* Products Grid Skeleton */}
      <Box
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
          gap: "16px",
          padding: "0",
        }}
      >
        {Array.from({ length: 12 }).map((_, index) => (
          <Box
            key={index}
            style={{
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              padding: "16px",
              margin: "8px",
              backgroundColor: "white",
              minHeight: "300px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Product Image Skeleton */}
            <Box style={{ textAlign: "center", marginBottom: "12px" }}>
              <Box
                style={{
                  width: "100%",
                  height: "200px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "4px",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            </Box>

            {/* Product Title Skeleton */}
            <Box
              style={{
                height: "16px",
                backgroundColor: "#f0f0f0",
                borderRadius: "4px",
                marginBottom: "8px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
            <Box
              style={{
                height: "16px",
                backgroundColor: "#f0f0f0",
                borderRadius: "4px",
                marginBottom: "8px",
                width: "80%",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />

            {/* Price Skeleton */}
            <Box
              style={{
                height: "20px",
                backgroundColor: "#f0f0f0",
                borderRadius: "4px",
                marginBottom: "8px",
                width: "60px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />

            {/* Rating Skeleton */}
            <Box
              style={{
                height: "16px",
                backgroundColor: "#f0f0f0",
                borderRadius: "4px",
                marginBottom: "8px",
                width: "100px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />

            {/* Brand Skeleton */}
            <Box
              style={{
                height: "12px",
                backgroundColor: "#f0f0f0",
                borderRadius: "4px",
                marginBottom: "8px",
                width: "120px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />

            {/* Product ID Skeleton */}
            <Box
              style={{
                height: "10px",
                backgroundColor: "#f0f0f0",
                borderRadius: "4px",
                marginTop: "auto",
                width: "80px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </Box>
        ))}
      </Box>

      {/* CSS Animation */}
      <style>
        {`
          @keyframes pulse {
            0% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
            100% {
              opacity: 1;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default SearchSkeleton;
